import { useState } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import * as EmailValidator from "email-validator";

export const useEmailAddressLogin = () => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    email: "",
    status: "normal",
    errorMessage: "",
  });

  const handleAddEmail = (e) => {
    setState({
      ...state,
      email: e.target.value,
    });
  };

  const handleLogin = () => {
    if (!EmailValidator.validate(state.email)) {
      setState({
        status: "error",
        errorMessage: "Invalid email format, use @domain.com for email address",
      });

      return;
    }

    setState({
      ...state,
      status: "normal",
      errorMessage: "",
    });

    handleOTP();
  };

  const handleOTP = () => {
    navigate({
      pathname: "/verification/email-address",
      search: `?${createSearchParams({
        type: "login",
        method: "Email",
        email: state.email,
      })}`,
    });
  };

  return {
    state,
    handleAddEmail,
    handleLogin,
  };
};
